export const HelpTerms = [
  {
    title: 'i18n.payments.paymentDashboard.helpModal.creditHold.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.creditHold.definition',
    dataCy: 'credit-hold',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.pastTerms.term',
    definition: 'i18n.payments.paymentDashboard.helpModal.pastTerms.definition',
    dataCy: 'past-terms',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.daysPastTerms.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.daysPastTerms.definition',
    dataCy: 'days-past-terms',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.closeToTerms.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.closeToTerms.definition',
    dataCy: 'close-to-terms',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.currentPercentage.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.currentPercentage.definition',
    dataCy: 'current-percentage',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.overdueInvoices.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.overdueInvoices.definition',
    dataCy: 'overdue-invoices',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.scheduledPayments.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.scheduledPayments.definition',
    dataCy: 'scheduled-payments',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.unusedCredits.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.unusedCredits.definition',
    dataCy: 'unused-credits',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.onHold.term',
    definition: 'i18n.payments.paymentDashboard.helpModal.onHold.definition',
    dataCy: 'on-hold',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.softHold.term',
    definition: 'i18n.payments.paymentDashboard.helpModal.softHold.definition',
    dataCy: 'soft-hold',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.active.term',
    definition: 'i18n.payments.paymentDashboard.helpModal.active.definition',
    dataCy: 'active',
  },
  {
    title: 'i18n.payments.paymentDashboard.helpModal.lastPaymentMethod.term',
    definition:
      'i18n.payments.paymentDashboard.helpModal.lastPaymentMethod.definition',
    dataCy: 'last-payment-method',
  },
];
